import Api from '@/config/api';

export default {
    namespaced: true,
    state: {
        allJobs: [],
        currentPage: 1,
        pageSize: 20,
        hasNext: false,
        loading: false,
        // page number -> cursor to request that page; page 1 is always cursor-less.
        // Cleared whenever page 1 is (re)loaded, since a cursor is only valid for the
        // search/filter it was issued under (see bloom-backend commit 939a4129).
        cursors: {},
    },
    mutations: {
        setJobs(state, jobs) {
            state.allJobs = jobs;
        },
        setPage(state, page) {
            state.currentPage = page;
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setCursor(state, { page, cursor }) {
            state.cursors = { ...state.cursors, [page]: cursor };
        },
        resetCursors(state) {
            state.cursors = {};
        },
    },
    actions: {
        async loadJobs({ commit, state }, { page = 1, searchKeyword = '', companyIds = null }) {
            try {
                commit('setLoading', true);
                await this._vm.$auth.getToken();
                if (page === 1) {
                    commit('resetCursors');
                }
                const params = {
                    jdSearchAnd: searchKeyword,
                };
                const cursor = page === 1 ? null : state.cursors[page];
                if (cursor) {
                    params.cursor = cursor;
                }

                if (Array.isArray(companyIds) && companyIds.length > 0) {
                    params.companyIds = companyIds.join(',');
                }

                const response = await this._vm.axios({
                    method: "get",
                    url: Api.url(Api.endpoints.allJds),
                    params,
                });

                const { jDs, hasNext, nextCursor } = response.data;
                commit('setJobs', jDs);
                commit('setHasNext', hasNext);
                commit('setPage', page);
                commit('setCursor', { page: page + 1, cursor: nextCursor });
                return jDs;
            } catch (err) {
                console.error("Error fetching jobs:", err);
                return [];
            } finally {
                commit('setLoading', false);
            }
        }
    },
    getters: {
        getJobs: state => state.allJobs,
        getCurrentPage: state => state.currentPage,
        getHasNext: state => state.hasNext,
        getLoading: state => state.loading,
        getPageSize: state => state.pageSize,
    }
}; 